import React from 'react';

/**
 * Kraya wordmark placeholder — swap for the official Kraya logo when available.
 */
export function KrayaLogo({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-2 ${className}`} data-id="element-10" data-mp="4yv4k2wqkpts">
      <svg viewBox="0 0 32 32" className="h-7 w-7" fill="none" aria-hidden="true" data-id="element-11" data-mp="4ymtmgk6bul8">
        <rect x="1" y="1" width="30" height="30" rx="9" stroke="#0a0a0a" strokeWidth="1.4" data-id="element-12" data-mp="8yx9qm1ok1dt" />
        <path d="M12 9v14M12 16l7-7M12 16l7 7" stroke="#a61e22" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-13" data-mp="3r5bnokzy8bc7" />
      </svg>
      <span className="text-xl font-semibold tracking-tightest text-ink" data-id="element-14" data-mp="3i6q6at67r2d0">Kraya</span>
    </span>;
}